import { coreColor, semanticRetroDark, semanticRetroLight } from '../tokens';
import { getDesignTypography } from './typography';
import { getDesignBreakpoints } from './breakpoints';
import { getDesignZIndex } from './zIndex';
import { getBoxShadow } from './shadow';
function getDesignColor() {
    return coreColor;
}
function getDesignSemantic() {
    return {
        light: semanticRetroLight,
        dark: semanticRetroDark,
    };
}
export function getDesign() {
    return {
        color: getDesignColor(),
        semantic: getDesignSemantic(),
        typography: getDesignTypography(),
        breakpoints: getDesignBreakpoints(),
        zIndex: getDesignZIndex(),
        shadow: getBoxShadow(),
    };
}
export function getDynamicSemanticToken(theme) {
    const semantic = theme?.zoomUI?.semantic ?? getDesignSemantic();
    const activeMode = theme?.palette?.mode ?? 'light';
    const targetModeSemantic = activeMode === 'light' ? semantic.light : semantic.dark;
    const dst = {
        ...targetModeSemantic,
        ...{ activeMode },
    };
    return dst;
}
